import Vue from 'vue';
import axios from 'axios';

import App from './App.vue';
import VathosAxiosImage from '@/components/ui/VathosAxiosImage.vue';
import vuetify from './plugins/vuetify';
import store from './store';
import router from './router/index';
import {i18n} from './plugins/i18n';
import './assets/stylus/main.styl';
import interceptors from './interceptors';
import VModal from 'vue-js-modal';
import Keycloak from 'keycloak-js';
import DatetimePicker from 'vuetify-datetime-picker';


Vue.config.productionTip = false;
// We need this as a global component
Vue.component('VathosAxiosImage', VathosAxiosImage);

// We use Keycloak auth if in a production or staging environment or we're forced to use it (e.g. during development)
const environment = process.env.VUE_APP_ENVIRONMENT;
const useKeycloak = environment === 'production' || environment === 'staging' || process.env.VUE_APP_FORCE_KEYCLOAK;

// If we don't use Keycloak auth we need to inject our specific headers to all API requests.
// We just default to 'vathos' for now.
if (!useKeycloak) {
  axios.defaults.headers.common['x-auth-groups'] = process.env.VUE_APP_CLIENT_ID || 'vathos';
  axios.defaults.headers.common['x-auth-roles'] = 'user';
}
Vue.prototype.$blobsUrl = process.env.VUE_APP_BLOBS_URL;
Vue.prototype.$votenetUrl = process.env.VUE_APP_VOTENET_URL;
Vue.prototype.$combineProductTask = process.env.VUE_APP_COMBINE_PRODUCT_TASK;
Vue.prototype.$captureServiceName = process.env.VUE_APP_CAPTURE_SERVICE_NAME;

Vue.prototype.$minimumTemperatureRange = parseFloat(process.env.VUE_APP_MINIMUM_TEMPERATURE_RANGE);
Vue.prototype.$maximumTemperatureRange = parseFloat(process.env.VUE_APP_MAXIMUM_TEMPERATURE_RANGE);
Vue.prototype.$minimumDepthRange = parseFloat(process.env.VUE_APP_MINIMUM_DEPTH_RANGE);
Vue.prototype.$maximumDepthRange = parseFloat(process.env.VUE_APP_MAXIMUM_DEPTH_RANGE);
Vue.prototype.$minFitnessRange = parseFloat(process.env.VUE_APP_MINIMUM_FITNESS_RANGE);
Vue.prototype.$maxFitnessRange = parseFloat(process.env.VUE_APP_MAXIMUM_FITNESS_RANGE);
Vue.prototype.$minRmseRange = parseFloat(process.env.VUE_APP_MINIMUM_RMSE_RANGE);
Vue.prototype.$maxRmseRange = parseFloat(process.env.VUE_APP_MAXIMUM_RMSE_RANGE);


Vue.prototype.$appEnvironment = environment;

Vue.use(VModal, {componentName: 'draggableModal'});
Vue.use(DatetimePicker);

let keycloak = undefined;
const keycloakInitOptions = {
  url: process.env.VUE_APP_KEYCLOAK_URL,
  realm: process.env.VUE_APP_KEYCLOAK_REALM,
  clientId: process.env.VUE_APP_KEYCLOAK_CLIENT_ID,
  onLoad: 'login-required',
};
if (useKeycloak) {
  keycloak = new Keycloak(keycloakInitOptions); // eslint-disable-line new-cap
}

interceptors(axios, router, keycloak);

// Set default timeout
axios.defaults.timeout = 180000;

if (useKeycloak) {
  keycloak.init({onLoad: keycloakInitOptions.onLoad, pkceMethod: 'S256', checkLoginIframe: false}).then((auth) => {
    if (!auth) { // eslint-disable-line promise/always-return
      window.location.reload();
    }
    console.log('Successful login for user: ' + keycloak.tokenParsed.preferred_username);
    Vue.prototype.$keycloak = keycloak;
    const userData = {
      username: keycloak.tokenParsed.preferred_username,
      firstName: keycloak.tokenParsed.given_name,
      lastName: keycloak.tokenParsed.family_name,
      email: keycloak.tokenParsed.email,
    };
    Vue.prototype.$userData = userData;

    new Vue({
      i18n,
      vuetify,
      store,
      router,
      render: (h) => h(App),
    }).$mount('#app');
  }).catch(() => {
    console.log('Failed to authenticate.');
  });
} else {
  new Vue({
    i18n,
    vuetify,
    store,
    router,
    render: (h) => h(App),
  }).$mount('#app');
}
